import Modal from './Modal.jsx'
import Button from './Button.jsx'

/** Styled replacement for native confirm() — used anywhere a destructive
 *  action (delete page, delete client, …) needs a confirmation step. */
export default function ConfirmDialog({ open, onClose, onConfirm, title = 'Are you sure?', description, confirmLabel = 'Delete', danger = true }) {
  return (
    <Modal open={open} onClose={onClose} title={title} width={360}>
      {description && <p className="text-muted text-[13.5px] mb-5 leading-relaxed">{description}</p>}
      <div className="flex gap-2">
        <Button variant="ghost" className="flex-1" onClick={onClose}>Cancel</Button>
        <Button variant={danger ? 'danger' : 'primary'} className="flex-1" onClick={() => { onConfirm(); onClose() }}>
          {confirmLabel}
        </Button>
      </div>
    </Modal>
  )
}
